



















import {Component} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import DebounceMixin from '@/mixins/DebounceMixin';
import LoadingMixin from '@/mixins/LoadingMixin';
import SnackbarMixin from '@/mixins/SnackbarMixin';
import {swalSuccess, swalError, swalWarning} from '@/plugins/swal';
import {jobsModule} from '@/store/modules/jobs';
import {SET_EXPIRE, SET_POINT, SET_ID_QUIZ} from '@/store/mutationTypes';
import moment from 'moment';

@Component
export default class Introduction extends mixins(
  LoadingMixin,
  SnackbarMixin,
  DebounceMixin,
) {
  @jobsModule.Mutation(SET_EXPIRE) setExpire!: Function;
  @jobsModule.Mutation(SET_POINT) setPoint!: Function;
  @jobsModule.Mutation(SET_ID_QUIZ) setIDSetting!: Function;

  introductionList = {
    name: '',
    time_limit: 0,
    description: '',
  };
  timeQuiz = null;

  async mounted() {
    await this.facthDataUser();
    await this.facthData();
  }
  async facthData() {
    try {
      this.startLoading('detail');
      const res = await this.$store.dispatch('jobs/getQuizIntroduction');
      if (res.data.data) {
        this.finishLoading('detail');
        this.setExpire(res.data.data.time_limit);
        this.setPoint(res.data.data.min_correct_answer);
        this.setIDSetting(res.data.data);
        this.introductionList = res.data.data;
      } else {
        swalWarning.fire({
          title: 'Warning!',
          text: 'Mohon maaf saat ini informasi quiz belum tersedia.',
        });
        setTimeout(() => this.$router.push('/'), 500);
      }
    } catch (e) {
      swalError.fire({
        title: 'Failed!',
        text:
          e.response?.error?.message ||
          'Sebuah kesalahan yang tidak diduga telah terjadi.',
      });
    }
  }
  async facthDataUser() {
    try {
      this.startLoading('detail');
      const res = await this.$store.dispatch('jobs/getQuizIntroductionUser');
      if (res.data.data) {
        if (res.data.data.status === 1) {
          swalError.fire({
            title: 'Failed!',
            text: `Mohon maaf Anda Sudah melakukan test`,
          });
          this.$router.push('/');
        } else if (
          res.data.data.status === 0 &&
          moment().diff(moment(res.data.data.createdAt, 'YYYY-MM-DD'), 'days') <
            192
        ) {
          swalError.fire({
            title: 'Failed!',
            text: `Mohon maaf Anda tidak lolos dalam Pre-Test. Silahkan melakukan Pre-Test kembali ${moment(
              res.data.data.createdAt,
              'YYYY-MM-DD',
            )
              .add(192, 'days')
              .diff(
                moment(res.data.data.createdAt, 'YYYY-MM-DD'),
                'days',
              )} hari kedepan.`,
          });
          this.$router.push('/');
        }
      }
    } catch (e) {
      swalError.fire({
        title: 'Failed!',
        text:
          e.response?.error?.message ||
          'Sebuah kesalahan yang tidak diduga telah terjadi.',
      });
    }
  }
  async startQuiz() {
    try {
      const formData = {
        start_time: new Date(),
        status: null,
      };
      const resJobs = await this.$store.dispatch('jobs/newQuiz', formData);
      if (resJobs) {
        this.$router.push('/quiz');
      }
    } catch {
      swalError.fire({
        title: 'Failed!',
        text:
          'Mohon maaf belum dapat memulai quiz, harap kontak administrator.',
      });
    }
  }
  convertSecond(countDown: any) {
    const h = Math.floor(countDown / 3600);
    const m = Math.floor((countDown % 3600) / 60);
    const s = Math.floor((countDown % 3600) % 60);

    const hDisplay = h > 0 ? h + ' Jam ' : '';
    const mDisplay = m > 0 ? m + ' Menit ' : '';
    const sDisplay = s > 0 ? s + ' Detik' : '';
    return hDisplay + mDisplay + sDisplay;
  }
}
